import compact from 'lodash/compact';

import type { MedicalHistoryFormValues, MedicalHistoryRequestValues } from 'src/app/types/medicalHistoryForm';

import { MEDICATIONS_DELIMITER } from '../utils';

export const formValuesToRequest = (values: MedicalHistoryFormValues): MedicalHistoryRequestValues => {
  const { allergies, allergiesToggle, conditions, conditionsToggle, medications } = values;

  return {
    allergies: allergiesToggle && allergies ? allergies : 'None',
    medicalConditions: conditionsToggle && conditions ? conditions : 'None',
    otherMedications: medications.join(MEDICATIONS_DELIMITER) || 'None',
    potentialTransfers: null,
  };
};

export const formValuesToAnalyticsProps = (values: MedicalHistoryFormValues) => {
  const { allergies, conditions, medications, doctors, allergiesToggle, conditionsToggle, noMedicationsCheckbox } =
    values;
  return {
    allergies: allergies || '',
    conditions: conditions || '',
    medications: medications.join(MEDICATIONS_DELIMITER) || '',
    doctors: compact(doctors).join(MEDICATIONS_DELIMITER) || '',
    allergiesToggle: allergiesToggle || '',
    conditionsToggle: conditionsToggle || '',
    medicationsToggle: !noMedicationsCheckbox ? 'Yes' : 'No',
  };
};
